import cicd from './../images/cicd.png';

const CICD = () => {
  return (
    <div>
    <p className="standard-paragraph">
    <div class="container">
      <div class="image-container">
       <img src={cicd} alt="CI/CD" width={300}/>
     </div>
     <div class="text-container">
       <h2>CI/CD</h2>
       <p class="text-text">
       Accelerate your software development lifecycle with our AWS CI/CD pipeline solutions. Seamlessly automate code integration, 
       testing, and deployment for faster releases and improved reliability. Explore our comprehensive software development services, 
       offering end-to-end CI/CD pipeline implementation, configuration, and optimization to streamline your development processes.
       </p>
     </div>
   </div>
    
    <ul class="custom-list">
    <li><strong>Source Code Management:</strong> Use a source code repository like AWS CodeCommit or GitHub.</li>
    <li><strong>Build Automation:</strong> Employ AWS CodeBuild or Jenkins for automated build processes.</li>
    <li><strong>Artifact Repository:</strong> Store build artifacts in Amazon S3 or CodeArtifact.</li>
    <li><strong>Containerization:</strong> Utilize Amazon ECR for container image storage.</li>
    <li><strong>Orchestration:</strong> Use AWS ECS or EKS for container orchestration.</li>
    <li><strong>Serverless Deployment:</strong> Deploy serverless applications with AWS Lambda and API Gateway.</li>
    <li><strong>Deployment Automation:</strong> Automate deployments with AWS CodeDeploy or Elastic Beanstalk.</li>
    <li><strong>Infrastructure as Code (IaC):</strong> Define infrastructure with AWS CloudFormation or Terraform.</li>
    <li><strong>Pipeline Orchestration:</strong> Set up a CI/CD pipeline with AWS CodePipeline or Jenkins.</li>
    <li><strong>Test Automation:</strong> Integrate automated testing using AWS services.</li>
    <li><strong>Blue/Green Deployments:</strong> Implement blue/green deployments for minimal downtime.</li>
    <li><strong>Security Scanning:</strong> Use scanning tools to identify vulnerabilities and ensure compliance.</li>
    <li><strong>Monitoring and Alerting:</strong> Set up monitoring with AWS CloudWatch, CloudTrail, and X-Ray.</li>
    <li><strong>Release Management:</strong> Establish clear release management processes.</li>
    <li><strong>Continuous Improvement:</strong> Continuously evaluate and improve the CI/CD pipeline for efficiency and reliability.</li>
</ul>
</p>
</div>)
};

export default CICD;
